import { GetSetSuperArgsFunction, IsFactoryClass, MakeFactory } from '../../../../classes/class-helpers/factory';
import { BaseClass } from '../../../../classes/class-helpers/base-class';
import { IS_OBSERVABLE_LIKE_CONSTRUCTOR, IsObservableLikeConstructor } from '../../../../core/observable/constructor';
import { ObservableFactory } from '../../../../core/observable/implementation';
import { DISTINCT_VALUE_OBSERVABLE_PRIVATE } from './privates';
import { ConstructDistinctValueObservable, IS_VALUE_OBSERVABLE_CONSTRUCTOR } from './constructor';
export function DistinctValueObservableOnObserved(instance, observer) {
    const privates = instance[DISTINCT_VALUE_OBSERVABLE_PRIVATE];
    if (privates.lastCountPerObserver.has(observer)) {
        if (privates.count !== privates.lastCountPerObserver.get(observer)) {
            observer.emit(privates.value, instance);
        }
        privates.lastCountPerObserver.delete(observer);
    }
    else {
        if (privates.count !== 0) {
            observer.emit(privates.value, instance);
        }
    }
    privates.onObserveHook(observer);
}
export function DistinctValueObservableOnUnobserved(instance, observer) {
    const privates = instance[DISTINCT_VALUE_OBSERVABLE_PRIVATE];
    privates.lastCountPerObserver.set(observer, privates.count);
    privates.onUnobserveHook(observer);
}
export function PureDistinctValueObservableFactory(superClass) {
    if (!IsObservableLikeConstructor(superClass)) {
        throw new TypeError(`Expected Observables' constructor as superClass`);
    }
    const setSuperArgs = GetSetSuperArgsFunction(IsFactoryClass(superClass));
    return class DistinctValueObservable extends superClass {
        constructor(...args) {
            const [create] = args[0];
            let context;
            super(...setSuperArgs(args.slice(1), [
                (_context) => {
                    context = _context;
                    return {
                        onObserved: (observer) => {
                            DistinctValueObservableOnObserved(this, observer);
                        },
                        onUnobserved: (observer) => {
                            DistinctValueObservableOnUnobserved(this, observer);
                        }
                    };
                }
            ]));
            ConstructDistinctValueObservable(this, context, create);
        }
    };
}
export let DistinctValueObservable;
export function DistinctValueObservableFactory(superClass) {
    return MakeFactory(PureDistinctValueObservableFactory, [], superClass, {
        name: 'DistinctValueObservable',
        instanceOf: DistinctValueObservable,
        waterMarks: [IS_VALUE_OBSERVABLE_CONSTRUCTOR, IS_OBSERVABLE_LIKE_CONSTRUCTOR],
    });
}
export function DistinctValueObservableBaseFactory(superClass) {
    return MakeFactory(PureDistinctValueObservableFactory, [ObservableFactory], superClass, {
        name: 'DistinctValueObservable',
        instanceOf: DistinctValueObservable,
        waterMarks: [IS_VALUE_OBSERVABLE_CONSTRUCTOR, IS_OBSERVABLE_LIKE_CONSTRUCTOR],
    });
}
DistinctValueObservable = class DistinctValueObservable extends DistinctValueObservableBaseFactory(BaseClass) {
    constructor(create) {
        super([create], []);
    }
};
//# sourceMappingURL=implementation.js.map